import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=0b505588"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports